import SectionLabel from "./SectionLabel";
import { Reveal } from "./Reveal";

export default function Legacy() {
    return (
        <section
            id="legacy"
            data-testid="legacy-section"
            className="scroll-mt-20 px-6 py-28 sm:py-36"
        >
            <div className="mx-auto max-w-6xl">
                <SectionLabel id="legacy">The Legacy</SectionLabel>
                <div className="mt-14 grid gap-12 md:grid-cols-12">
                    <Reveal className="md:col-span-9">
                        <h2 className="font-display text-[clamp(2.1rem,5vw,4rem)] font-light leading-[1.12] text-cream">
                            Legacy meets a{" "}
                            <span className="italic text-gold">
                                new generation
                            </span>
                            .
                        </h2>
                    </Reveal>
                    <div className="space-y-8 text-[15px] leading-relaxed text-cream/75 md:col-span-8 md:col-start-5">
                        <Reveal delay={0.1}>
                            <p>
                                Mountain View Pictures draws on a foundation of
                                three decades of production experience, industry
                                relationships, and established production
                                infrastructure, with a next-generation approach
                                led by Pranav.
                            </p>
                        </Reveal>
                        <Reveal delay={0.18}>
                            <p>
                                The studio pairs that inherited discipline with
                                an international, co-production-led outlook —
                                carrying Chennai&rsquo;s craft to partners and
                                audiences far beyond it.
                            </p>
                        </Reveal>
                        <Reveal delay={0.26}>
                            <p className="font-display text-xl italic text-cream/90 sm:text-2xl">
                                The summit is inherited. The climb is new.
                            </p>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
